export default "__VITE_ASSET__DgzhVGW8__"